import { ApplicationAccessCountryZoneCountryModel } from '@/Models/ApplicationAccessCountryZones/ApplicationAccessCountryZoneCountryModel';
import { ApplicationAccessCountryZoneModel } from '@/Models/ApplicationAccessCountryZones/ApplicationAccessCountryZoneModel';

export function addZone(
  countryZones: ApplicationAccessCountryZoneCountryModel[],
  model: ApplicationAccessCountryZoneModel,
) {
  if (isTopLevel(model)) {
    addCountryZone(countryZones, model);
  } else {
    const countryZone = countryZoneUtils.countryZoneById(model.parentId, countryZones);
    if (countryZone) {
      countryZone.zoneLevels.push(model);
    }
  }
}

function shouldUpdateZoneLevel(
  zoneLevel: ApplicationAccessCountryZoneModel,
  model: ApplicationAccessCountryZoneModel,
  selectedUuid: string,
) {
  if (selectedUuid !== '') {
    return zoneLevel.uuid === selectedUuid;
  }
  return zoneLevel.id === model.id;
}

export function updateZone(
  countryZones: ApplicationAccessCountryZoneCountryModel[],
  model: ApplicationAccessCountryZoneModel,
  selectedUuid = '',
) {
  if (isTopLevel(model)) {
    updateCountryZone(countryZones, model, selectedUuid);
  } else {
    const countryZone = countryZoneUtils.countryZoneById(model.parentId, countryZones);
    if (countryZone) {
      countryZone.zoneLevels = countryZone.zoneLevels.map((zoneLevel) => {
        return shouldUpdateZoneLevel(zoneLevel, model, selectedUuid) ? model : zoneLevel;
      });
    }
  }
}

export function deleteZone(countryZones: ApplicationAccessCountryZoneCountryModel[], modelId: string | number) {
  deleteCountryZone(countryZones, modelId);
  deleteZoneLevel(countryZones, modelId);
}

export function isTopLevel(x: ApplicationAccessCountryZoneModel): boolean {
  return !x.parentId || x.parentId === '';
}

function countryZoneById(countryZoneId: string | number, zones: ApplicationAccessCountryZoneCountryModel[]) {
  for (const zone of zones) {
    for (const logistic of zone.logistics) {
      const countryZone = logistic.countryZones.find((cz) => cz.id == countryZoneId);
      if (countryZone) {
        return countryZone;
      }
    }
  }

  return null;
}

function addCountryZone(
  countryZones: ApplicationAccessCountryZoneCountryModel[],
  model: ApplicationAccessCountryZoneModel,
) {
  const countryZone = countryZones.find((x) => x.country === model.countryCode);
  if (countryZone) {
    let logistic = countryZone.logistics.find((x) => x.logisticId == model.logisticTypeId);
    if (logistic) {
      logistic.countryZones.push(model);
    } else {
      logistic = {
        country: model.countryCode,
        logisticId: Number(model.logisticTypeId),
        countryZones: [model],
      };
      countryZone.logistics.push(logistic);
    }
  }
}

function updateCountryZone(
  countryZones: ApplicationAccessCountryZoneCountryModel[],
  model: ApplicationAccessCountryZoneModel,
  selectedUuid = '',
) {
  const countryZone = countryZones.find((x) => x.country === model.countryCode);
  if (countryZone) {
    const logistic = countryZone.logistics.find((x) => x.logisticId == model.logisticTypeId);
    if (logistic) {
      logistic.countryZones = logistic.countryZones.map((zoneLevel) => {
        return shouldUpdateZoneLevel(zoneLevel, model, selectedUuid) ? model : zoneLevel;
      });
    }
  }
}

function deleteCountryZone(countryZones: ApplicationAccessCountryZoneCountryModel[], id: string | number) {
  countryZones.forEach((x) => {
    x.logistics.forEach((y) => (y.countryZones = y.countryZones.filter((z) => z.id !== id)));
    x.logistics = x.logistics.filter((y) => y.countryZones.length !== 0);
  });
}

function deleteZoneLevel(zones: ApplicationAccessCountryZoneCountryModel[], id: string | number) {
  zones.forEach((x) => {
    x.logistics.forEach((y) =>
      y.countryZones.forEach((z) => {
        z.zoneLevels = z.zoneLevels.filter((level) => level.id != id);
      }),
    );
  });
}

export const countryZoneUtils = {
  addZone,
  updateZone,
  deleteZone,
  countryZoneById,
  isTopLevel,
};
